const { SITE_NAME, BRAND_NAME } = process.env;

export default (state) => {
	return {
		"@context": "https://schema.org",
		"@type": "BreadcrumbList",
		"itemListElement": [
			{
				"@type": "ListItem",
				"position": 1,
				"item": {
					"@id": `https://${SITE_NAME}.com/`,
					"name": BRAND_NAME,
					"url": `https://${SITE_NAME}.com/`,
				},
			},
			{
				"@type": "ListItem",
				"position": 2,
				"item": {
					"@id": `https://${SITE_NAME}.com/${state.abbreviation.toLowerCase()}/`,
					"name": `${state.abbreviation.toUpperCase()}`,
					"url": `https://${SITE_NAME}.com/${state.abbreviation.toLowerCase()}/`,
				},
			},
		],
	};
};
